export function formatNumeroAnalisis(
  numeroProtocolo: number,
  numeroAnalisis: number | null | undefined,
): string | null {
  if (numeroAnalisis == null) return null;
  return `${numeroProtocolo}/${numeroAnalisis}`;
}
